<script lang="ts">
    import type {LevnaknihovnaLoanability, LoanRequestOption} from 'src/typings';
    import {getInjector, getLocalization, getSanitize} from 'src/core';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import {LoanRequestFormService} from '../loan-request-form.service';
    import {strParams} from 'shared/utils/pipes';
    import {pipe} from 'core/utils';
    import LoginFirstButton from './shared/LoginFirstButton.svelte';
    import SendLoanRequestButton from './shared/SendLoanRequestButton.svelte';
    import OpenOnExternalLoanProviderWebsiteLink from './shared/OpenOnExternalLoanProviderWebsiteLink.svelte';
    import HelpDisclosure from './shared/HelpDisclosure.svelte';
    import LoanOptionPanelBody from './shared/LoanOptionPanelBody.svelte';

    export let option: LoanRequestOption<LevnaknihovnaLoanability>;

    const localize = getLocalization();
    const sanitize = getSanitize();
    const service = getInjector().getByClass(LoanRequestFormService);

    $: showLoginButtonFirst = service.requiresLogin(option);
    $: requesterEmail = option.formObject.requester.email;
</script>
<KpGenericPanel>
    <strong slot="heading">
        {localize(/* @kp-localization loan.levnaknihovna.VypujcitDoCteckyPresLevnaknihovna */ 'loan.levnaknihovna.VypujcitDoCteckyPresLevnaknihovna')}
    </strong>

    <LoanOptionPanelBody>
        {#if !showLoginButtonFirst}
            <HelpDisclosure>
                <svelte:fragment slot="summary">
                    {localize(/* @kp-localization loan.levnaknihovna.JakPujcovat */ 'loan.levnaknihovna.JakPujcovat')}
                </svelte:fragment>
                <svelte:fragment slot="details">
                    <ol class="loan-request-list">
                        <li>{localize(/* @kp-localization loan.levnaknihovna.KlikneteNaVypujcit */ 'loan.levnaknihovna.KlikneteNaVypujcit')}</li>
                        <li>
                            {@html sanitize(
                                pipe(
                                    localize(/* @kp-localization loan.levnaknihovna.NaEmailXObdrzitePoukaz */ 'loan.levnaknihovna.NaEmailXObdrzitePoukaz'),
                                    strParams(`<strong>${requesterEmail}</strong>`))
                            )}
                        </li>
                    </ol>
                </svelte:fragment>
            </HelpDisclosure>
        {/if}

        <div>
            <p>{localize(/* @kp-localization loan.levnaknihovna.JakCistKnihy */ 'loan.levnaknihovna.JakCistKnihy')}</p>
            <div>
                {localize(/* @kp-localization commons.viz */ 'commons.viz')}
                <a href="https://www.levna-knihovna.cz/page/static/jak-cist-knihy" target="_blank">
                    https://www.levna-knihovna.cz/page/static/jak-cist-knihy
                </a>
            </div>
        </div>

        <div>
            {localize(/* @kp-localization loan.levnaknihovna.DodatecneInformace */ 'loan.levnaknihovna.DodatecneInformace')}
        </div>

        <OpenOnExternalLoanProviderWebsiteLink capability={option.capability}>
            {localize(/* @kp-localization loan.levnaknihovna.ZobrazitKnihuNaLevnaknihovna */ 'loan.levnaknihovna.ZobrazitKnihuNaLevnaknihovna')}
        </OpenOnExternalLoanProviderWebsiteLink>

        {#if showLoginButtonFirst}
            <LoginFirstButton/>
        {:else}
            <SendLoanRequestButton {option} apiPath="/loan-items/request/externalLendingRequest">
                {localize(/* @kp-localization loan.levnaknihovna.Vypujcit */ 'loan.levnaknihovna.Vypujcit')}
            </SendLoanRequestButton>
        {/if}
    </LoanOptionPanelBody>
</KpGenericPanel>